export enum FOOTER_POPUP_ACTION {
  '给销售' = 3,
  '转交给同事' = 2,
  '标记不相关' = 5,
  '重复' = 6,
  '给经销商' = 8
}
